import { makeStyles } from "tss-react/mui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleCheck, faArrowUpRightFromSquare } from "@fortawesome/pro-solid-svg-icons"
import { Box, List, ListItem, ListItemButton, ListItemIcon, Typography } from "@mui/material"
import { LocalizedEnum, LocalizedStrict } from "../../localization/components/AppLocalized"
import { useExternalLinks } from "../../../shared/hooks/useAppLinks"
import { AdminRole } from "../../users/userTypes"
import { CardContentBox } from "./CardElements"

const useStyles = makeStyles()((theme) => ({
    listItem: {
        paddingLeft: 0,
        paddingRight: 0,
    },
    listIconWrap: {
        minWidth: "1.5rem",
    },
    iconColor: {
        color: theme.palette.tailwind.green[500],
    },
    textColor: {
        color: theme.palette.tailwind.slate[900],
        fontWeight: 500,
    },
    button: {
        gap: "0.5rem",
        color: "#2196f3",
        width: "fit-content",
        position: "relative",
        left: "-1rem",
    },
    lightColor: {
        color: theme.palette.text.secondary,
    },
}))

type RolesCardProps = { roles?: AdminRole[] }

export const RolesCard = ({ roles }: RolesCardProps) => {
    const { classes } = useStyles()
    const handleExternalLink = useExternalLinks()
    return (
        <CardContentBox
            title={
                <LocalizedStrict id="profile-roles">
                    <>Your roles</>
                </LocalizedStrict>
            }
            wrapSpacing="0.5rem"
            listSpacing="0.5rem"
        >
            {roles && !!roles.length ? (
                <List>
                    {Object.values(AdminRole)
                        .filter((role) => roles?.includes(role))
                        .map((role) => (
                            <ListItem className={classes.listItem} key={role}>
                                <ListItemIcon className={classes.listIconWrap}>
                                    <FontAwesomeIcon icon={faCircleCheck} className={classes.iconColor} />
                                </ListItemIcon>
                                <LocalizedEnum base="profile-roles-mode" enumValue={role}>
                                    <Typography variant="subtitle1" className={classes.textColor}>
                                        {role}
                                    </Typography>
                                </LocalizedEnum>
                            </ListItem>
                        ))}
                </List>
            ) : (
                <LocalizedStrict id="profile-roles-no-roles">
                    <Typography variant="body2" className={classes.lightColor}>
                        You have no roles
                    </Typography>
                </LocalizedStrict>
            )}
            {roles && !!roles.length && (
                <Box>
                    <ListItemButton onClick={() => handleExternalLink("/")} className={classes.button}>
                        <LocalizedStrict id="profile-roles-read-more">
                            <>Read about administrator roles</>
                        </LocalizedStrict>
                        <FontAwesomeIcon icon={faArrowUpRightFromSquare} className={classes.lightColor} />
                    </ListItemButton>
                </Box>
            )}
        </CardContentBox>
    )
}
